<med-notification-container
  *ngIf="!notification.custom"
  [type]="notification.type || defaultType"
  [showCloseAction]="closable"
  (close)="closeClicked()"
>
  <ng-container *ngIf="!template">
    <div class="med-notification-item__notification">
      <div
        *ngIf="notification.title"
        class="med-notification-item__title"
      >
        {{ notification.title }}
      </div>

      <div class="med-notification-item__text">{{ notification.text }}</div>
    </div>
  </ng-container>

  <ng-container *ngTemplateOutlet="template; context: { $implicit: notification }"></ng-container>
</med-notification-container>

<ng-container *ngIf="notification.custom">
  <ng-container *ngTemplateOutlet="template; context: { $implicit: notification }"></ng-container>
</ng-container>
